import { createStore } from "satcheljs";
import { ObservableMap, ObservableSet } from "mobx";
import { IPreviewSchedulePageStore } from "./PreviewSchedulePageStore";
import { initialScheduleViewStateStore } from "../../schedules/lib/store/store";
import { IBaseConflictEntity, IMemberEntity, INoteEntity, IOpenShiftEntity, IShiftEntity, ITagEntity, ScheduleCalendarTypes, ScheduleOverViewTypes, ShiftFilterType } from "../../../../sh-models";
import { ScheduleComponents } from "../../schedules/lib/store/ScheduleComponents";
import * as moment from "moment";

const initialStore: IPreviewSchedulePageStore = {
    ...initialScheduleViewStateStore,

    // Override with new ObservableMap instances to avoid sharing references
    notesInView: new ObservableMap<string, INoteEntity>(),
    shiftsInView: new ObservableMap<string, IShiftEntity>(),
    openShiftsInView: new ObservableMap<string, IOpenShiftEntity>(),
    newlyEditedEntities: new ObservableMap<string, boolean>(),
    datesWithNewEdits: new ObservableMap<string, boolean>(),
    filteredMembers: new ObservableMap<string, IMemberEntity>(),
    filteredTags: new ObservableMap<string, ITagEntity>(),
    selectedShiftFilters: new ObservableMap<string, ShiftFilterType>(),
    conflictsInView: new ObservableMap<string, IBaseConflictEntity[]>(),
    renderedComponents: new ObservableSet<ScheduleComponents>(),

    // Preview schedule specific properties - always use PeopleView
    isViewGrouped: true,
    scheduleOverViewType: ScheduleOverViewTypes.PeopleView,
    scheduleCalendarType: ScheduleCalendarTypes.Week,
    viewSelectedDate: moment(),                               // the date selected by the user (today by default)
    viewStartDate: moment(),                                  // the start date of the current view (today by default). For example, for week view this would be the start date of the week.
    viewEndDate: moment(),
    isDataInDateRangeLoaded: false,
    isViewStatePopulated: false,                              // Explicitly set to false initially
    collapsedTags: [],                                        // Ensure collapsedTags is initialized to prevent indexOf errors
    groupsInView: [],                                         // Ensure groupsInView is initialized
    membersInView: [],                                        // Ensure membersInView is initialized

    selectedTagId: null,
    isPageOpen: false,
    startDate: null,
    endDate: null,
    jobId: "",
    generateOption: null
};

const previewSchedulePageStore = createStore<IPreviewSchedulePageStore>(
    "previewSchedulePageStore",
    initialStore
);

export default previewSchedulePageStore;